import React, { Component, KeyboardEvent } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { ILoginComponent, LoginType } from "./index";
import { ILoader } from "../index";
import TextInputField from "@my-dld/components/Form/TextInputField";
import JqDatePicker from "@my-dld/components/JQDatePicker";
import { DateUtil, ServerDate, StringUtil } from "@eres/core";
import { PickerItem } from "@my-dld/components/Picker";
import { Entities, IdentityApi } from "@10x/dubai-rest-api";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import SwitchStrip from "@my-dld/components/SwitchStrip";
import DateInputField from "@eres/forms-web/DateInputField";
import StateHolder from "@eres/forms/StateHolder";
import { ErrorContainer } from "@eres/forms";
import { showErrorMessage } from "@my-dld/utils/UIUtils";

const PropertyTypes: PickerItem[] = [
	{
		id: "3",
		value: LVStrings.unit,
	},
	{
		id: "4",
		value: LVStrings.villa,
	},
	{
		id: "2",
		value: LVStrings.building,
	},
	{
		id: "1",
		value: LVStrings.land,
	},
];

// type viewTypes = "certificateNumber" | "certificateYear" | "propertyType";

interface State {
	certNumber?: string;
	certDate?: Date;
	pDetail?: string;
	pType?: PickerItem;
	resError?: string;
	today: Date;
	dob?: ServerDate;
	errorContainer: ErrorContainer;
}


export class TitleDeedLogin extends Component<any, State> implements ILoginComponent<any, State> {
	constructor( props: any ) {
		super( props );
		this.state = {
			certNumber: "",
			pDetail: "",
			certDate: undefined,
			pType: PropertyTypes[ 0 ],
			errorContainer: {},
			today: new Date(),
		};
	}

	render() {
		const ds = StateHolder.buildStateHolder( this );

		return (
			<React.Fragment>
				{
					this.state.resError && <div className="col-md-12">
						<div className={ "form-input-error alert alert-danger" }>
							{ this.state.resError }
						</div>
					</div>
				}
                <div className="row g-3">
					<TextInputField
                        containerClassName={ "col-6" }
						inputClassName={ "form-control" }
						placeHolder={ Strings.certificate_number }
						id={ "certNumber" }
						required={ true }
						holder={ this }
						error={ this.state.errorContainer.number }
						label={ Strings.certificate_number }
						maxLength={ 10 }
						inputProps={ {
							type: "text",
							onKeyPress: event => {
								if ( !/[0-9]/.test( event.key ) ) {
									event.preventDefault();
								}
							}
						} }
					>
					</TextInputField>
					<JqDatePicker
						required={ true }
						label={ Strings.issue_date }
                           containerClassName={ "col-6" }
						//inputClassName={ "form-control " }
						value={ this.state.certDate }
						error={ this.state.errorContainer.date }
						onDateSet={ ( d ) => {
							this.setState( { certDate: d } );
						} }
						id={ "cert_date_x" }
						opts={ {
							changeMonth: true,
							changeYear: true,
							dateFormat: "dd-mm-yy",
							maxDate: this.state.today,
							defaultDate: this.state.certDate,
							showOn: "both",
							buttonText: "",
							showAnim: "slideDown",
						} }
					/>
                    <SwitchStrip
                        containerClassName={ "checkbox-wrapper mb-3 info-span-hide" }
                        label={ Strings.property_type }
                        items={ PropertyTypes }
                        value={ this.state.pType }
                        id={ "source" }
                        onSelect={ value => this.setState( {
                            pType: value,
                        } ) }
                    />
                    <div className="col-12">
                        <label htmlFor="propertyType"><span>{Strings.property_type}</span><span className="asterisk"> *</span></label>
                        <select className="form-select" id="propertyType">
                            <option>Unit</option>
                            <option>Villa</option>
                            <option>Building</option>
                            <option>Land</option>
                        </select>
                    </div>
				    <TextInputField
				    	containerClassName={ "col-6" }
				    	inputClassName={ "form-control empty-validation" }
				    	placeHolder={ Strings.certificate_person_detail }
				    	id={ "pDetail" }
				    	holder={ this }
				    	required={ true }
				    	error={ this.state.errorContainer.pDetail }
				    	inputProps={ {
				    		onKeyPress: this.onKeyUp,
				    	} }
				    	label={ Strings.certificate_person_detail }>
				    </TextInputField>
				    <DateInputField
				    	containerClassName={ "col-6" }
				    	required={ true }
				    	holder={ ds }
				    	label={ Strings.date_of_birth }
				    	id={ "dob" }
				    	extraOpts={ {
				    		maxDate: this.state.today,
				    		yearRange: "-100:+0"
				    	} }
				    />
                </div>
			</React.Fragment>
		);
	}

	onKeyUp = ( event: KeyboardEvent<any> ) => {
		if ( event.charCode === 13 ) {
			this.props.doLogin();
		}
	};
	doLogin = ( loader: ILoader ) => {
		let isValid = true;
		const errorContainer: ErrorContainer = {};

		if ( StringUtil.isEmptyStringOrNull( this.state.certNumber ) ) {
			errorContainer.number = Strings.please_enter_valid_certificate_no;
			isValid = false;
		}
		if ( this.state.certDate == null ) {
			errorContainer.date = Strings.please_enter_valid_issue_date;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( this.state.dob ) ) {
			errorContainer[ "dob" ] = Strings.please_enter_dob;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( this.state.pDetail ) ) {
			errorContainer[ "pDetail" ] = Strings.please_enter_valid_owner_number_name;
			isValid = false;
		}
		this.setState( { errorContainer: errorContainer } );
		if ( isValid ) {
			loader.setLoading( true );
			const dateX = DateUtil.formatDate( this.state.certDate!, "DD/MM/YYYY", "en" );
			let certInfo = this.state.certNumber + "|" + dateX + "|" + this.state.pType?.id;
			if ( this.state.pDetail !== undefined && this.state.pDetail !== "" ) {
				certInfo = certInfo + "|" + this.state.pDetail;
			}
			trackEventWithData( "Login", "TryLogin", { method: "TitleDeed", id: certInfo } );
			return IdentityApi.loginByCertificate( certInfo, this.state.dob! )
			.then( Entities.validateResponse )
			.then( profile => {
				loader.setLoading( false );
				return {
					result: profile,
					method: "TitleDeed" as LoginType,
					id: certInfo,
					dob: this.state.dob!
				};
			} ).catch( e => {
				loader.setLoading( false );
				showErrorMessage( e );
				return Promise.reject();
			} );
		}
		loader.setLoading( false );
		return Promise.reject();
	};
}
